import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './en'
import zhHantTW from './zh-Hant-TW'

i18n.use(initReactI18next).init({
  resources: { en, 'zh-Hant-TW': zhHantTW },
  lng: 'zh-Hant-TW',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export default i18n
